import * as React from 'react';
import styled from 'styled-components';

import backgroundSrc from '../../assets/images/ea-patt.png';

const StPatternBackground = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  opacity: 0.5;
  background-repeat: repeat;
  background-image: url(${backgroundSrc});
`;

class PatternBackground extends React.Component {
  render() {
    return <StPatternBackground />;
  }
}

export default PatternBackground;



// WEBPACK FOOTER //
// ./src/app/dashboard/components/PatternBackground.tsx